// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 590 ? "main" : chunkId) + "." + {"588":"48e98d577e9116791751","590":"f0943c4e1d3195ea71d7"}[chunkId] + ".css";
};